import Vue from 'vue';
import router from './podcasts/router';
import axios from 'axios';
import lodash from 'lodash';
import App from './podcasts/App'
import VueRouter from 'vue-router'
import VDragged from "v-dragged";
import store from './podcasts/store/'

Vue.use(VDragged)
Vue.prototype.$page = window.page;

Vue.prototype.$axios = axios;
Vue.prototype.$wmtVideoAxios = axios.create({
  baseURL: window.page.wmt_video.base
})
Vue.prototype.$lodash = lodash;

Vue.use(VueRouter)
Vue.component('app', App);

new Vue({
  el: '#app',
  router,
  store
});
